export const HEADER_ID = "stats-hero-header";
